import $ from 'jquery'
import { post } from 'base/lib/network'
import Event from 'base/event'
import apiUrl from 'base/api_url'
import {
  startRequest,
  resetLineItems,
  blockCart,
  openCart,
  unblockCart,
  finishRequest,
  fireEvent,
  setAddToCartErrorMessage,
} from 'base/actions/synchronous'

import { fetchOrderPreview } from 'base/actions/asynchronous'

const cartIsBlocked = getState => {
  return getState().cart.isBlocked
}

const lineItem = (quantity, variant, product, unit, withCart) => {
  const timestamp = Date.now().toString()
  const lineItemAttributes = {
    quantity,
    variant_id: variant.id,
    product_id: product.id,
    collection_id: product.collection_id,
    price: product.price,
    with_cart: withCart,
    timestamp,
  }

  return addUnit(lineItemAttributes, unit)
}

const addUnit = (attributes, unit) => {
  if (!unit) {
    return attributes
  }

  if (unit.notify_at) {
    unit.notify_at = new Date(unit.notify_at).toUTCString()
  }

  return {
    ...attributes,
    unit_attributes: unit,
    unit_type: 'GiftcardReservation',
  }
}

// Send over variant object with product_id and price -- used by lib/trackers/facebook.js
// Data currently relies on variant fields like SKU, etc., in the current
// format (sent as lineItem).
// Facebook requires product_id, price, along with variant.id.
const event = (variant, product, location, collection, timestamp, unit) => {
  const synthesizedVariant = {
    ...variant,
    unit,
    product_id: product.id,
    price: product.price,
    display_name: product.display_name,
  }

  return {
    location,
    collection,
    timestamp,
    bundle_item: !!product.bundle_info,
    variant: synthesizedVariant,
  }
}

export default ({
  product,
  variant,
  unit,
  collection,
  quantity = 1,
  location = 'add_to_bag',
  withCart,
}) => {
  return (dispatch, getState) => {
    if (cartIsBlocked(getState)) {
      return new $.Deferred().reject('Cart is already being modified')
    }

    let path = 'line_items'
    if (withCart) {
      path += '/create_simple_with_cart'
    }

    dispatch(startRequest())
    dispatch(blockCart())

    const lineItemData = lineItem(quantity, variant, product, unit, withCart)

    return post(apiUrl(path), lineItemData)
      .then(response => {
        if (!withCart) {
          dispatch(resetLineItems(response.cart.line_items))
        }
        dispatch(fetchOrderPreview(null, { include_promos_in_subtotal: true }))
        dispatch(openCart())
        dispatch(unblockCart())
        dispatch(finishRequest())
        dispatch(
          fireEvent(
            Event.Checkout.ADD_TO_CART,
            event(variant, product, location, collection, lineItemData.timeStamp, unit),
          ),
        )
        return response
      })
      .fail(error => {
        const errorMessage =
          error.responseJSON && error.responseJSON.message
            ? error.responseJSON.message
            : 'Hmm. Something went wrong.'

        dispatch(setAddToCartErrorMessage(errorMessage))
        dispatch(unblockCart())
        dispatch(finishRequest())
      })
  }
}
